import { render, staticRenderFns } from "./province.vue?vue&type=template&id=4ad8e08a&scoped=true&"
import script from "./province.vue?vue&type=script&lang=js&"
export * from "./province.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad8e08a",
  null
  
)

export default component.exports